import script from "./Detail.vue?vue&type=script&setup=true&lang=js"
export * from "./Detail.vue?vue&type=script&setup=true&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=f5be1cfa&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5be1cfa"]])

export default __exports__